// State / province lists and postal-code rules shared by every address form.
// Postal regexes mirror backend/app/services/address_rules.py.

export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
  'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
  'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC',
];

export const CA_PROVINCES = ['AB','BC','MB','NB','NL','NS','NT','NU','ON','PE','QC','SK','YT'];

const CA_POSTAL = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/;
const US_ZIP = /^\d{5}(-\d{4})?$/;

export function isValidPostal(country, value) {
  const v = (value || '').trim();
  if (country === 'CA') return CA_POSTAL.test(v.replace(/[\s-]/g, '').toUpperCase());
  return US_ZIP.test(v);
}

// Text for a failed profile save: the server's readable 400 detail when it
// sent one (e.g. "Enter a Canadian postal code like L9G 4Z6."), else a generic.
export function saveErrorText(error) {
  const detail = error && error.response && error.response.data && error.response.data.detail;
  return typeof detail === 'string' && detail ? detail : 'Error saving';
}
